import { createAction } from '../../../store.model';
import { TranscriptQuote } from '../../../teams-call';
import { ActionType } from '../transcript-dialog.action';

export interface SelectQuotes {
    quotes: TranscriptQuote[];
    mode?: 'toggle-all' | 'set' | null | undefined;
}

export const selectQuotes = createAction<ActionType, SelectQuotes>(
    ActionType.COACHING_DETAIL__TD__SELECT_QUOTES,
);
